import { configureThemes, THEMES } from "@fanduel/formation-theming";

// formation still exposes proxima nova font names, so this map points them to the approved local fonts
// once formation provides approved font tokens, use the upstream theme directly and remove this map
export const formationThemes = configureThemes(THEMES, {
  fontMap: {
    "Proxima Nova": "var(--font-roboto)",
    "Proxima Nova Condensed": "var(--font-roboto-condensed)",
  },
});
